/**
 * Weather source codes — RainViewer remains the default active radar provider.
 * Open-Meteo model sources are registered as active free forecast/historical sources.
 * IDEAM is the open-data historical radar research path; SIATA remains planned partnership.
 * OpenWeather is planned paid backlog only.
 */

export const WEATHER_SOURCE_CODES = {
  RAINVIEWER_RADAR: "RAINVIEWER_RADAR",
  IDEAM_RADAR: "IDEAM_RADAR",
  SIATA_SANTA_ELENA: "SIATA_SANTA_ELENA",
  SIATA_RAIN_GAUGES: "SIATA_RAIN_GAUGES",
  OPEN_METEO_FORECAST: "OPEN_METEO_FORECAST",
  OPEN_METEO_HISTORICAL: "OPEN_METEO_HISTORICAL",
  OPENWEATHER_FORECAST: "OPENWEATHER_FORECAST",
};

export const WEATHER_SOURCE_ACCESS_TYPES = {
  OPEN_DATA: "OPEN_DATA",
  FREE_PUBLIC_API: "FREE_PUBLIC_API",
};

export const WEATHER_SOURCE_REGISTRY_STATUS = {
  PLANNED_OPEN_DATA: "PLANNED_OPEN_DATA",
  LOCAL_FILES_AVAILABLE: "LOCAL_FILES_AVAILABLE",
  LOCAL_CACHE_AVAILABLE: "LOCAL_CACHE_AVAILABLE",
};

export const DEFAULT_RADAR_SOURCE_CODE = WEATHER_SOURCE_CODES.RAINVIEWER_RADAR;
export const DEFAULT_MODEL_FORECAST_SOURCE_CODE = WEATHER_SOURCE_CODES.OPEN_METEO_FORECAST;

export const OPEN_DATA_RADAR_SOURCE_CODES = new Set([WEATHER_SOURCE_CODES.IDEAM_RADAR]);

export const PLANNED_RADAR_SOURCE_CODES = new Set([
  WEATHER_SOURCE_CODES.IDEAM_RADAR,
  WEATHER_SOURCE_CODES.SIATA_SANTA_ELENA,
]);

export const PLANNED_PAID_MODEL_SOURCE_CODES = new Set([
  WEATHER_SOURCE_CODES.OPENWEATHER_FORECAST,
]);

export function isOpenDataRadarSource(sourceCode) {
  return OPEN_DATA_RADAR_SOURCE_CODES.has(sourceCode);
}

export function isPlannedRadarSource(sourceCode) {
  return PLANNED_RADAR_SOURCE_CODES.has(sourceCode);
}

export function isPlannedPaidModelSource(sourceCode) {
  return PLANNED_PAID_MODEL_SOURCE_CODES.has(sourceCode);
}
